<div
    class="bg-white py-[0.9375rem] md:px-[7.5rem] sm:px-16 px-4 h-[4.375rem] w-full drop-shadow-md grid gap-4 grid-cols-3">
    <div class="flex items-center">
        @if (hideBackButton) {
            <div class="flex items-center gap-2 cursor-pointer" (click)="back()">
                <div class="w-6 h-6 flex items-center justify-center">
                    <img
                        src="/assets/images/shared/CaretLeft.png"
                        alt="Caret Left"
                        class="w-full h-full object-contain" />
                </div>
                <div class="text-[#061F4C] text-sm font-bold">Back</div>
            </div>
        }
    </div>
    <div class="flex sm:gap-2 gap-1 items-center justify-center">
        <img class="w-auto h-8" src="/assets/images/shared/text_logo.png" alt="p2p" />
    </div>
    <div></div>
</div>
